import * as React from 'react'

interface SidebarContextProps {
  open: boolean
  setOpen: (open: boolean) => void
}

export const SidebarCotenxt = React.createContext<SidebarContextProps>(
  {} as SidebarContextProps,
)
SidebarCotenxt.displayName = 'SidebarCotenxt'

export const SidebarContextProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const [open, setOpen] = React.useState(false)

  return (
    <SidebarCotenxt.Provider value={{ open, setOpen }}>
      {children}
    </SidebarCotenxt.Provider>
  )
}

export const useSidebar = (): SidebarContextProps =>
  React.useContext(SidebarCotenxt)
